<template>
  <div>
    <div class="header"></div>
    <div class="news">
      <div class="content" v-if="tableData.length != 0">
        <el-table
          :data="tableData"
          style="width: 100%"
          :header-cell-style="{ background: '#E3E3E3', color: '#606266',textAlign: 'center',fontSize:'18px' }"
        >
          <el-table-column prop="rowNo" label="序号" width="100" align="center"></el-table-column>
          <el-table-column prop="SFJDJGXKZH" label="许可证号" align="center"></el-table-column>
          <el-table-column prop="SFJDJGMC" label="机构名称" width="180"></el-table-column>
          <el-table-column prop="JGZSXXDZ" label="机构地址"></el-table-column>
          <el-table-column prop="YWFW" label="业务范围"></el-table-column>
          <el-table-column prop="JGLXDH" label="联系电话" align="center"></el-table-column>
          <!-- <el-table-column prop="BZJG" label="认证认可情况"></el-table-column> -->
        </el-table>
      </div>
      <div id="without" class="content" v-if="tableData.length == 0">
        暂无数据
      </div>
      <div class="hint">*备注: 此排名根据许可证号进行排序</div>
      <div class="tail">
        <div class="download" @click="download">下载名录</div>
        <!-- 分页器 -->
        <div class="paging">
          <pagination
            :totalPage="totalPage"
            @sizeChange="sizeChange"
            @currentChange="currentChange"
          ></pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { membersData, getRecordExport } from "../../../api/officialWebsite";
import { applyMemberInstitutionOverrides } from "../../../data/memberInstitutionOverrides";
import pagination from "../../common/pagination";

export default {
  components: {
    pagination,
  },
  data() {
    return {
      showCount: 10, // 总记录数容量   如:15条/页
      totalPage: 0, // 总条数 共X条
      currentPage: 1, // 当前页
      tableData: [], // 表格数据
    };
  },
  created() {
    this.getList();
  },
  methods: {
    download() {
      getRecordExport({
        showCount: this.showCount,
        currentPage: this.currentPage,
      });
    },
    // pageSize 改变时会触发
    sizeChange(val) {
      this.showCount = val;
      this.currentPage = 1;
      this.getList();
    },
    // currentPage 改变时会触发
    currentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    getList() {
      membersData({
        showCount: this.showCount,
        currentPage: this.currentPage,
      }).then((res) => {
        if (res.result == 1) {
          this.tableData = applyMemberInstitutionOverrides(res.list);
          this.totalPage = res.totalResult;
        } else {
          this.$message.error("访问失败");
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  width: 1920px;
  height: 400px;
  background: url("../../../../static/wy/banner8.png") no-repeat center center;
  background-size: 100% 100%;
}
.news {
  width: 70%;
  // height: 1051px;
  background: url("../../../../static/wy/bj.png") no-repeat;
  // background-size: 100% 100%;
  margin: 0 auto;
  margin-top: -90px;
  overflow: hidden;
  margin-bottom: 120px;
  .content {
    width: 85%;
    // height: 600px;
    margin: 0 auto;
    margin-top: 70px;
    margin-bottom: 30px;
  }
  .hint{
    color: red;
    margin-left: 73%;
    margin-bottom: 10px;
  }
  .tail {
    width: 85%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .download {
      width: 128px;
      height: 46px;
      background: #ffffff;
      border: 1px solid #585858;
      border-radius: 10px;
      line-height: 46px;
      text-align: center;
      cursor: pointer;
    }
  }
}
</style>
